import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import {
  Avatar,
  Box,
  Card,
  CardContent,
  Grid,
  Typography,
  colors,
  makeStyles
} from '@material-ui/core';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import AccessibilityNewIcon from '@material-ui/icons/AccessibilityNew';

const useStyles = makeStyles((theme) => ({
  root: {
    height: '100%'
  },
  avatar: {
    backgroundColor: colors.blue[900],
    height: 50,
    width: 50
  },
  differenceIcon: {
    color: colors.green[900]
  },
  differenceValue: {
    color: colors.green[900],
    marginRight: theme.spacing(1)
  }
}));

const MobilityTrack = ({ className, ...rest }) => {
  const classes = useStyles();

  return (
    <Card
      className={clsx(classes.root, className)}
      {...rest}
    >
      <CardContent>
        <Grid
          container
          justify="space-between"
          spacing={3}
        >
          <Grid item xs={1} style={{marginRight: 30}}>
            <Avatar className={classes.avatar}><AccessibilityNewIcon /></Avatar>
          </Grid>
          <Grid item xs={10}>
            <Typography
              style={{color: "#002D55", marginBottom: 5}}
              gutterBottom
              variant="h5"
            >
              MOBILITY
            </Typography>
            <Typography
              style={{marginTop: 5, marginBottom: 5}}
              color="textSecondary"
              gutterBottom
              variant="h7"
            >
              See how much you have improved your mobility. 
            </Typography>
            <Box
          mt={2}
          display="flex"
          alignItems="center"
        >
          <ArrowDownwardIcon className={classes.differenceIcon} />
          <Typography
            className={classes.differenceValue}
            variant="body2"
          >
            12%
          </Typography>
          <Typography
            color="textSecondary"
            variant="caption"
          >
            Since last month
          </Typography>
        </Box>
          </Grid>
        </Grid>
        
      </CardContent>
    </Card>
  );
};

MobilityTrack.propTypes = {
  className: PropTypes.string
};

export default MobilityTrack;